export default __webpack_public_path__ + "static/119-2da6dc6ec46c22484841af09aadb5cfb.jpg";